/**
 * @module services/zotero/libraryService
 * @description Library and group management for Zotero API
 */

import { apiClient } from './apiClient';
import { translate } from '@/i18n';
import type { Library, ZoteroGroup, ServiceResult } from '@types';

// =============================================================================
// LIBRARY SERVICE
// =============================================================================

/**
 * Get user library info
 */
export async function getUserLibrary(userId: number): Promise<ServiceResult<Library>> {
  try {
    await apiClient.request<unknown>({
      method: 'GET',
      path: `/users/${userId}`,
    });

    const library: Library = {
      id: userId,
      name: translate('library.myLibrary'),
      type: 'user',
      collections: [],
    };

    return { success: true, data: library };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to get library',
    };
  }
}

/**
 * Get user's groups
 */
export async function getGroups(userId: number): Promise<ServiceResult<ZoteroGroup[]>> {
  try {
    const response = await apiClient.request<ZoteroGroup[]>({
      method: 'GET',
      path: `/users/${userId}/groups`,
    });

    return { success: true, data: response.data || [] };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to get groups',
    };
  }
}
